import { apiDelete, apiGet, apiPatch, apiPost } from './client';

export function getMyTeams() {
  return apiGet('/me/teams');
}

export function getTeamMembers(teamId) {
  return apiGet(`/teams/${teamId}/members`);
}

export function createTeam(name) {
  return apiPost('/teams', { name });
}

export function getTeamOverview(teamId) {
  return apiGet(`/teams/${teamId}/overview`);
}

export function addTeamMember(teamId, userId, customRole = null) {
  return apiPost(`/teams/${teamId}/members`, {
    user_id: Number(userId),
    custom_role: customRole || null
  });
}

export function removeTeamMember(teamId, userId) {
  return apiDelete(`/teams/${teamId}/members/${Number(userId)}`);
}

export function updateTeamMemberCustomRole(teamId, userId, customRole = null) {
  return apiPatch(`/teams/${teamId}/members/${Number(userId)}/custom-role`, {
    custom_role: customRole || null
  });
}

export function leaveTeam(teamId) {
  return apiPost(`/teams/${teamId}/leave`);
}

export function deleteTeam(teamId) {
  return apiDelete(`/teams/${teamId}`);
}

export function sendTeamInvite(teamId, userId, message) {
  return apiPost(`/teams/${teamId}/invites`, {
    user_id: Number(userId),
    message: String(message || '').trim(),
  });
}

export function assignTeamCaptain(teamId, userId) {
  return apiPatch(`/teams/${teamId}/captain/${Number(userId)}`);
}
